/**
 * @file store getters
 * @author wangzhongpeng
 */

export default {
  regionList(state) {
    const { rawRegionList = [] } = state;

    const list = rawRegionList.map(i => ({
      ...i,
      com: i.regionId + ',' + i.regionName
    }));

    const first = list.filter(i => i.regionType === 1);
    const sec = list.filter(i => i.regionType === 2);
    const third = list.filter(i => i.regionType === 3);

    sec.forEach(i => {
      const regionId = i.regionId;
      const arr = third.filter(item => item.parentId === regionId);
      i.children = arr;
    });

    first.forEach(i => {
      const regionId = i.regionId;
      const arr = sec.filter(item => item.parentId === regionId);
      i.children = arr;
    });

    return first;
  },
  user(state) {
    return state.user;
  },
  isLogin(state) {
    return !!state.user;
  }
};
